module.exports = "<form (ngSubmit)='onSubmit()'>\r\n    <ng-content></ng-content>\r\n</form>"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/easyForms/components/form/form.component.html
// module id = ../../../../../app/shared/components/easyForms/components/form/form.component.html
// module chunks = main